<template>
  <div>
    <ProjectCardList
      :projects="filteredProjects"
      :recent-projects="searchQuery ? [] : recentProjects"
    ></ProjectCardList>
    <div
      v-if="searchQuery && filteredProjects.length === 0"
      class="projects-empty"
    >
      No projects match “{{ searchQuery }}”.
    </div>
  </div>
</template>

<script>
//import ProjectModel from '../models/ProjectModel'
import ProjectCardList from '../components/ProjectCardList'
import { licensingEngineApi } from 'licensing-engine-sdk'

export default {
  components: {
    ProjectCardList
  },
  data() {
    return {
      name: 'Dummy Project Name',
      licenses: []
    }
  },
  computed: {
    filteredProjects() {
      return this.$store.getters['ProjectStore/filteredProjects']
    },
    recentProjects() {
      return this.$store.getters['ProjectStore/recentlyVisitedProjects']
    },
    searchQuery() {
      return this.$store.state.ProjectStore.searchQuery
    }
  },
  created: function() {
    this.$store.dispatch('ProjectStore/fetchProjects')
    this.$store.dispatch('ProjectStore/loadRecentlyVisited')
    this.$store.dispatch('OrganizationStore/fetchOrganizationsForUsers')
  },
  async mounted() {
    const qwe = await licensingEngineApi('domain').getLicenses[''].GET()
    this.licenses = qwe
  },
  beforeDestroy() {
    this.$store.commit('ProjectStore/SET_SEARCH_QUERY', '')
  },
  methods: {}
}
</script>

<style scoped>
.projects-empty {
  padding: 32px 16px;
  color: rgba(255, 255, 255, 0.55);
  font-size: 14px;
}
</style>
